<template>
    <div class="Datatable">
        <div
            v-if="busy"
            class="Datatable--loader"
        >
            <div class="loader"></div>
        </div>
        <!-- /.Datatable--loader -->
        <div class="Datatable--controls">
            <label class="Datatable--lengthMenu">
                <!-- <menu-options
                    :columns="columns"
                    :columns-to-show="columnsToShow"
                    :group-by="groupBy"
                    :settings="settings"
                    :group-by-options="groupByOptions"
                    class="mrs"
                    @columns-to-show-changed="setColumnsToShow"
                    @settings-changed="setSettings"
                    @group-by-changed="setGroupBy"
                ></menu-options> -->
                {{ sLengthMenuParts[0] }}
                <select
                    v-model="currentPageLength"
                    name="length"
                >
                    <option
                        v-for="option in lengthMenuOptions"
                        :key="option.value"
                        :value="option.value"
                        v-text="option.text"
                    ></option>
                </select>
                {{ sLengthMenuParts[1] }}
            </label>

            <slot
                name="controls"
                :group-by="groupBy"
                :select-group-by="selectGroupBy"
            ></slot>

            <!-- /.Datatable--lengthMenu -->
            <label class="Datatable--search">
                {{ trans('app.search').titleCase() }}
                <input
                    v-model="searchQuery"
                    type="search"
                    name="search"
                >
                <a
                    v-if="searchQuery"
                    class="Datatable--filter-btn clear"
                    @click.prevent="searchQuery = ''"
                >
                </a>
            </label>
            <!-- /.Datatable--search -->
        </div>
        <!-- /.Datatable--controls -->
        <div
            v-if="selected.length && selectActions"
            class="sticky Datatable--selected"
        >
            <span
                class="Datatable--selected-label"
            >{{ 'app.items_selected' | transChoice(selected.length, { count: selected.length }) }}</span>

            <a
                v-for="(action, index) in selectActions"
                :key="index"
                :href="action.href"
                v-bind="action.attribs"
                class="Datatable--selected-action"
                @click.prevent="handleAction(action)"
                v-html="action.label"
            ></a>
        </div>
        <div :class="{'Datatable--table-container-outer mt-4 rounded-md overflow-hidden border-b border-gray-200 shadow': responsive}">
            <div :class="{'Datatable--table-container-fade': responsive}"></div>
            <div
                v-if="!busy"
                :class="{'Datatable--table-container': responsive}"
            >
                <table
                    v-stackable-table="stackable"
                    v-bind="tableFullAttributes"
                >
                    <thead v-if="headerColumns && headerColumns.length">
                        <tr>
                            <th
                                v-if="selectable"
                                class="selection center sorting_disabled"
                            >
                                <input
                                    ref="selectall"
                                    v-model="selectAll"
                                    type="checkbox"
                                >
                            </th>
                            <template v-for="(column, index) in headerColumns">
                                <th
                                    v-if="columnIsVisible(columns[index])"
                                    :key="index"
                                    v-bind="column.attributes"
                                    :width="columns[index].width || null"
                                    :class="thClass(index)"
                                    @click="sortBy($event, columns[index].name)"
                                    v-html="column.title"
                                ></th>
                            </template>
                        </tr>

                        <tr
                            v-if="searchColumns && searchColumns.length"
                            class="Datatable--filter"
                        >
                            <th
                                v-if="selectable"
                                class="sorting_disabled"
                            ></th>
                            <template v-for="(search, index) in searchColumns">
                                <th
                                    v-if="columnIsVisible(columns[index])"
                                    :key="'search-' + index"
                                    :class="{'search_disabled': searchInputIsDisabled(columns[index]),
                                             'sorting_disabled': true}"
                                    class="sorting_disabled"
                                >
                                    <template v-if="columns[index].searchable_options">
                                        <label v-if="hasSingleSearchOptionsLoaded(columns[index])">
                                            <input-autocomplete
                                                v-model="singleSearchQueries[columns[index].name]"
                                                :lookup-array="getFormattedColumnOptions(columns[index])"
                                                :min-chars="0"
                                                :group-by="getColumnOptionsGroupByKey(columns[index])"
                                                :service-url="''"
                                                :placeholder="singleSearchPlaceholder(columns[index])"
                                            ></input-autocomplete>
                                            <template v-if="! searchInputIsDisabled(columns[index])">
                                                <a
                                                    v-if="singleSearchQueries[columns[index].name]"
                                                    class="Datatable--filter-btn clear"
                                                    @click.prevent="singleSearchQueries[columns[index].name] = ''"
                                                >

                                                </a>
                                            </template>
                                        </label>
                                        <label v-else>
                                            <input
                                                type="text"
                                                placeholder="Loading..."
                                                disabled
                                            >
                                        </label>
                                    </template>

                                    <template v-else-if="columns[index].searchable_date_range">
                                        <label>
                                            <date-picker
                                                :ref="`date-picker-${columns[index].name}`"
                                                v-model="singleSearchQueries[columns[index].name]"
                                                :name="`search[${columns[index].name}]`"
                                                :format="dateFormat"
                                                :value-type="datePickerValueParser"
                                                range
                                                editable
                                                append-to-body
                                                range-separator="-"
                                                allow-half-range
                                                width="100%"
                                                lang="en"
                                            ></date-picker>
                                        </label>
                                    </template>

                                    <template v-else>
                                        <label>
                                            <input
                                                v-model="singleSearchQueries[columns[index].name]"
                                                :name="`search[${columns[index].name}]`"
                                                :placeholder="singleSearchPlaceholder(columns[index])"
                                                :disabled="searchInputIsDisabled(columns[index])"
                                                type="search"
                                            >
                                            <template v-if="! searchInputIsDisabled(columns[index])">
                                                <a
                                                    v-if="singleSearchQueries[columns[index].name]"
                                                    class="Datatable--filter-btn clear"
                                                    @click.prevent="singleSearchQueries[columns[index].name] = ''"
                                                >
                                                </a>
                                            </template>
                                        </label>
                                    </template>
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <template v-if="groupedResults">
                        <template
                            v-for="(results, groupId) in groupedResults"
                        >
                            <thead
                                v-if="isGrouped"
                                :key="`${groupId}-header`"
                                :class="{'Datatable--group': true, 'expanded': groupIsExpanded(groupId), 'collapsed': !groupIsExpanded(groupId)}"
                                @click="toggleGroupExpanded($event, groupId)"
                            >
                                <tr :class="{ 'selected' : groupIsSelected(groupId) && groupIsExpanded(groupId) }">
                                    <td
                                        v-if="selectable && (!isGrouped || groupIsExpanded(groupId))"
                                        class="selection center"
                                    >
                                        <input
                                            v-if="!isGrouped || groupIsExpanded(groupId)"
                                            :ref="`selected-groups-${groupId}`"
                                            v-model="selectedGroups"
                                            name="selected-groups[]"
                                            type="checkbox"
                                            :value="groupId"
                                        >
                                    </td>
                                    <td :colspan="columns.length + (selectable && (!isGrouped || groupIsExpanded(groupId)) ? 2 : selectable ? 1 : 0)">
                                        <span
                                            v-if="groupIsExpanded(groupId)"
                                            class="material-icons Datatable--group-toggle-icon"
                                        >keyboard_arrow_down</span>
                                        <span
                                            v-else
                                            class="material-icons Datatable--group-toggle-icon"
                                        >keyboard_arrow_right</span>
                                        <slot
                                            name="group-header"
                                            v-bind="results[0]"
                                            :auth-user="authUser"
                                        >
                                            {{ groupId }}
                                        </slot>
                                    </td>
                                </tr>
                            </thead>

                            <tbody
                                v-show="groupIsExpanded(groupId)"
                                :key="`tbody-${groupId}`"
                                :class="{
                                    'Datatable--body': true,
                                    'expanded': groupIsExpanded(groupId),
                                    'collapsed': !groupIsExpanded(groupId)
                                }"
                            >
                                <tr v-if="isGrouped && loadingGroupItems">
                                    <td :colspan="columns.length + (selectable ? 1 : 0)">
                                        <p class="center mb0">
                                            <span class="loader small"></span>
                                        </p>
                                    </td>
                                </tr>
                                <template v-else>
                                    <tr
                                        v-for="(row, rowNumber) in results"
                                        :key="`${groupId}-${rowNumber}`"
                                        :class="{ 'selected' : rowIsSelected(row) }"
                                        @click="rowClicked($event, row)"
                                    >
                                        <td
                                            v-if="selectable"
                                            class="selection center"
                                        >
                                            <input
                                                :ref="`checkbox-row-${row.id}`"
                                                v-model="selected"
                                                :value="rowValue(row)"
                                                name="selected[]"
                                                type="checkbox"
                                            >
                                        </td>
                                        <template v-for="(column, columnNumber) in columns">
                                            <td
                                                v-if="columnIsVisible(column)"
                                                :key="columnNumber"
                                                :class="column.class"
                                            >
                                                <slot
                                                    :name="column.slot_name || column.name"
                                                    v-bind="row"
                                                    :auth-user="authUser"
                                                >
                                                    <span v-html="getColumnContent(row, column)"></span>
                                                </slot>
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                    </template>

                    <tbody v-else>
                        <tr class="odd">
                            <td
                                :colspan="columns.length + (selectable ? 1 : 0)"
                                valign="top"
                                class="Datatable--empty"
                            >
                                <template v-if="busy">
                                    Loading...
                                </template>
                                <template v-else-if="searchQuery">
                                    No matching records found
                                </template>
                                <template v-else>
                                    No data available in table
                                </template>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="footerColumns && footerColumns.length">
                        <tr>
                            <th v-if="selectable"></th>
                            <th
                                v-for="(column, index) in footerColumns"
                                :key="index"
                                v-bind="column.attributes || null"
                                v-text="column.title || column"
                            ></th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <!-- /.Datatable--table-container' -->
        </div>
        <!-- /Datatable--table-container-outer -->
        <nav aria-label="Pagination" class="flex items-center justify-between py-3">
            <div class="hidden sm:block">
                <p class="text-sm text-gray-700" v-text="infoString">
                </p>
            </div>
            <div
                v-if="buttons && buttons.length"
                class="flex justify-between flex-1 space-x-2 sm:justify-end"
            >
                <a
                    v-for="buttonAction in buttons"
                    :key="buttonAction"
                    href="#"
                    class="relative inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
                    @click.prevent="doAction(buttonAction)"
                >
                    {{ buttonAction }}
                </a>
            </div>

            <pagination
                v-model="startRecord"
                :total="recordsFiltered"
                :page-length="currentPageLength"
                @change="loadData"
            ></pagination>
        </nav>
    <!-- /.Datatable--footer-controls -->
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Pagination from './VueDatatablePagination.vue';
import MenuOptions from './VueDatatableMenuOptions.vue';
import { getUrlParam, pushUrlParam } from '../../helpers';

DatePicker.methods.selectStartDate = function (date) {
    this.$set(this.currentValue, 0, date);
    this.updateDate();
};

DatePicker.methods.selectEndDate = function (date) {
    this.$set(this.currentValue, 1, date);
    this.updateDate();
};

DatePicker.methods.isValidRangeValue = function (value) {
    return Array.isArray(value) && value.length === 2;
};

export default {
    components: {
        DatePicker,
        Pagination,
        MenuOptions,
    },
    props: {
        tableAttributes: {
            type: Object,
            default: null,
        },
        headerColumns: {
            type: Array,
            default: null,
        },
        searchColumns: {
            type: Array,
            default: null,
        },
        footerColumns: {
            type: Array,
            default: null,
        },
        selectable: {
            type: Boolean,
            default: null,
        },
        ajax: {
            type: String,
            default: '',
        },
        columns: {
            type: Array,
            default: null,
        },
        orderColumn: {
            type: Number,
            default: null,
        },
        orderDirection: {
            type: String,
            default: null,
        },
        buttons: {
            type: Array,
            default: null,
        },
        pageLength: {
            type: Number,
            default: 10,
        },
        stackable: {
            type: Boolean,
            default: null,
        },
        responsive: {
            type: Boolean,
            default: true,
        },
        selectActions: {
            type: [Array, Object],
            default: null,
        },
        language: {
            type: Object,
            default: () => ({
                sInfo: 'Showing _START_ to _END_ of _TOTAL_ items',
                sInfoEmpty: 'Showing 0 to 0 of 0 items',
                sInfoFiltered: '(filtered from _MAX_ total items)',
                sLengthMenu: 'Show _MENU_ items',
            }),
        },
        lengthMenu: {
            type: Array,
            default: () => [10, 25, 50, 100],
        },
        dateFormat: {
            type: String,
            default: 'MM/DD/YY',
        },
        echoChannel: {
            type: String,
            default: null,
        },
        defaultGroupBy: {
            type: String,
            required: false,
            default: null,
        },
        groupByOptions: {
            type: Object,
            required: false,
            default: () => {},
        },
    },

    data () {
        return {
            settings: {
                saveState: false,
            },
            searchTimeout: null,
            searchTimeoutTime: 300,
            loadDataTimeout: null,
            authUser: App.user,
            busy: false,
            pagination: null,
            sortedColumns: [],
            currentPageLength: this.pageLength,
            startRecord: 0,
            searchQuery: '',
            singleSearchQueries: [],
            singleSearchOptions: [],
            selectAll: false,
            selected: [],
            selectedGroups: [],
            expandedGroups: [],
            columnRenderers: [],
            columnsToShow: this.columns
                .filter(c => c.visible !== false)
                .map(c => c.name),
            groupBy: getUrlParam('group_by', this.defaultGroupBy),
            groupedResultsIds: [],
            loadingGroupItems: false,
        };
    },

    computed: {
        isGrouped () {
            return !! this.groupBy;
        },

        groupsWithAllRowsSelected () {
            if (! this.isGrouped) {
                return [];
            }
            const selectedIds = Object.keys(this.groupedResults).filter(groupId => {
                const group = this.groupedResults[groupId];
                return group.every(row => this.rowIsSelected(row.id));
            });

            return selectedIds.map(groupId => this.groupedResults[groupId]);
        },

        groupsIdsWithAtLeastOneRowSelected () {
            if (! this.isGrouped) {
                return [];
            }

            return Object.keys(this.groupedResults).filter(groupId => {
                const group = this.groupedResults[groupId];
                return group.some(row => this.rowIsSelected(row.id));
            });
        },

        datePickerValueParser () {
            return {
                value2date: value => (moment(value).isValid() ? moment(value).toDate() : null),
                date2value: date => date,
            };
        },

        /**
     * The key used to store the user settings in the local storage
     * @return {String}
     */
        localStorageKey () {
            return `datatable${window.location.pathname}${window.location.search}`;
        },

        /**
     * The curren user config (to be stored in local storage)
     * @return {Object}
     */
        userConfig () {
            return {
                sortedColumns: this.sortedColumns,
                singleSearchQueries: this.singleSearchQueries,
                currentPageLength: this.currentPageLength,
                searchQuery: this.searchQuery,
                startRecord: this.startRecord,
                columnsToShow: this.columnsToShow,
                settings: this.settings,
            };
        },

        /**
     * The pagination results isolated
     * @return {Array|null}
     */
        results () {
            if (! this.pagination) {
                return null;
            }

            return this.pagination.data;
        },

        /**
     * The pagination results isolated
     * @return {Array|null}
     */
        groupedResults () {
            if (! this.results || ! this.results.length) {
                return null;
            }

            if (! this.isGrouped) {
                return { 0: this.results };
            }

            return _.groupBy(this.results, i => i[this.groupBy]);
        },

        /**
     * The total records that exists
     * @return {Number|null}
     */
        recordsTotal () {
            if (! this.pagination) {
                return null;
            }

            return this.pagination.recordsTotal;
        },

        /**
     * The total records found
     * @return {Number|null}
     */
        recordsFiltered () {
            if (! this.pagination) {
                return null;
            }

            return this.pagination.recordsFiltered;
        },

        /**
     * The length menu select box options
     * @return {Array}
     */
        lengthMenuOptions () {
            if (typeof this.lengthMenu[0] === 'number') {
                return this.lengthMenu.map(option => ({
                    value: option,
                    text: option,
                }));
            }

            return this.lengthMenu[0].map((option, index) => {
                const text = this.lengthMenu[1] && this.lengthMenu[1][index]
                    ? this.lengthMenu[1][index]
                    : option;

                return {
                    value: option,
                    text,
                };
            });
        },

        /**
     * All the datatable attributes according to the options
     * @return {Array}
     */
        tableFullAttributes () {
            let className = `dataTable ${this.tableAttributes.class}`;
            if (! this.footerColumns || ! this.footerColumns.length) {
                className += ' no-footer';
            }

            return {
                ...this.tableAttributes,
                ...{
                    id: '',
                    class: className,
                },
            };
        },

        /**
     * The ajax columns formatted according to the datatable library
     * @return {Array}
     */
        ajaxColumns () {
            const columns = [];

            this.columns.forEach((column, index) => {
                let searchQuery = this.singleSearchQueries[column.name] || '';

                // If is a date range format the data for easy handling
                if (column.searchable_date_range && Array.isArray(searchQuery)) {
                    if (! searchQuery[0] && ! searchQuery[1]) {
                        searchQuery = '';
                    } else {
                        searchQuery[0] = moment(searchQuery[0]).isValid()
                            ? moment(searchQuery[0]).format('YYYY-MM-DD ')
                            : null;
                        searchQuery[1] = moment(searchQuery[1]).isValid()
                            ? moment(searchQuery[1]).format('YYYY-MM-DD ')
                            : null;
                    }
                }

                columns[`columns[${index}][data]`] = column.data;
                columns[`columns[${index}][name]`] = column.name;
                columns[`columns[${index}][searchable]`] = column.searchable;
                columns[`columns[${index}][orderable]`] = column.orderable;
                columns[`columns[${index}][search][value]`] = searchQuery;
                columns[`columns[${index}][search][regex]`] = false;
            });

            return columns;
        },

        /**
     * The order columns according to the datatable library
     * @return {Array}
     */
        orderColumns () {
            const columns = [];

            this.sortedColumns.forEach((column, index) => {
                const columnIndex = _.findIndex(this.columns, c => c.name === column.sortBy);
                columns[`order[${index}][column]`] = columnIndex;
                columns[`order[${index}][dir]`] = column.dir;
            });

            return columns;
        },

        /**
     * All the params that are sended to the loadData request
     * @return {Object}
     */
        ajaxParams () {
            return {
                ...{
                    draw: 1,
                    groupBy: this.groupBy || '',
                    start: this.startRecord,
                    length: this.currentPageLength,
                    'search[value]': this.searchQuery,
                    'search[regex]': false,
                },
                ...this.ajaxColumns,
                ...this.orderColumns,
            };
        },

        ajaxQuery () {
            const esc = encodeURIComponent;
            const pageQuery = window.location.search.substring(1);
            const query = Object.keys(this.ajaxParams)
                .map(k => `${esc(k)}=${esc(this.ajaxParams[k])}`)
                .join('&');

            return `${this.ajax}?${pageQuery}&${query}`;
        },

        /**
     * This query will return all the items in the grouped results
     * @return {String}
     */
        groupItemsAjaxQuery () {
            const esc = encodeURIComponent;
            const pageQuery = window.location.search.substring(1);
            const params = this.ajaxParams;

            delete params.start;
            delete params.length;

            params.groupByIds = this.groupedResultsIds;

            const query = Object.keys(params)
                .map(k => `${esc(k)}=${esc(params[k])}`)
                .join('&');

            return `${this.ajax}?${pageQuery}&${query}`;
        },

        /**
     * Divide the string in parts to add it into the template
     * @return {Array}
     */
        sLengthMenuParts () {
            return this.language.sLengthMenu.split('_MENU_');
        },

        /**
     * The results info string
     * @return {String}
     */
        infoString () {
            let string;

            if (this.busy) {
                return this.trans('app.datatable.busy');
            }

            if (this.recordsFiltered === 0) {
                string = this.language.sInfoEmpty;
            } else {
                string = this.language.sInfo
                    .replace('_START_', this.startRecord + 1)
                    .replace(
                        '_END_',
                        this.currentPageLength > 0
                            ? this.startRecord + this.currentPageLength
                            : this.recordsTotal,
                    )
                    .replace('_TOTAL_', this.recordsFiltered);
            }

            if (this.searchQuery) {
                string += ` ${this.language.sInfoFiltered.replace(
                    '_MAX_',
                    this.recordsTotal,
                )}`;
            }
            return string;
        },

        everyRowIsSelected () {
            if (! this.results) {
                return false;
            }

            return this.results.every(row => this.rowIsSelected(row));
        },

        /**
     * All the selected rows
     *
     * @return {Array}
     */
        selectedRows () {
            return this.results
                .filter(row => this.rowIsSelected(row))
            // The ID sometimes comes as an HTML string (for example as a link)
            // The followind method will ensure that the object send a raw ID
                .map(row => ({
                    ...row,
                    ...{
                        id: this.rowValue(row),
                    },
                }));
        },
    },

    watch: {
        selectedGroups (selectedGroups, previousSelectedGroups) {
            selectedGroups.forEach(groupId => {
                _.get(this.groupedResults, groupId, []).forEach(row => {
                    this.selectElement(row.id, false);
                });
            });

            const deleted = _.difference(previousSelectedGroups, selectedGroups);

            deleted.forEach(groupId => {
                _.get(this.groupedResults, groupId, []).forEach(row => {
                    this.unselectElement(row.id);
                });
            });
        },

        selected () {
            if (! this.isGrouped) {
                return;
            }

            _.forEach(this.groupedResults, (group, groupId) => {
                const allItemsInGroupAreSelected = group.every(row => this.rowIsSelected(row.id));
                if (allItemsInGroupAreSelected) {
                    this.selectGroup(groupId);
                } else {
                    this.unselectGroup(groupId);
                }
            });
        },

        everyRowIsSelected (everyRowIsSelected) {
            if (! everyRowIsSelected && this.selectAll) {
                this.selectAll = false;
            }
        },

        selectAll (selectAll) {
            if (selectAll && ! this.everyRowIsSelected && this.results) {
                const newRows = this.results.filter(row => ! this.rowIsSelected(row));
                this.selected = this.selected.concat(
                    newRows.map(row => this.rowValue(row)),
                );
            } else if (this.everyRowIsSelected) {
                this.selected = [];
            }
        },

        userConfig: {
            handler (userConfig) {
                localStorage.setItem(this.localStorageKey, JSON.stringify(userConfig));
            },
            deep: true,
        },

        singleSearchQueries: {
            handler () {
                clearTimeout(this.searchTimeout);

                this.searchTimeout = setTimeout(() => {
                    this.startRecord = 0;
                    this.loadData();
                }, this.searchTimeoutTime);
            },
            deep: true,
        },

        orderColumns () {
            this.loadData();
        },

        groupBy () {
            this.pagination = null;
            this.startRecord = 0;

            this.loadData();
        },

        searchQuery (searchQuery) {
            clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(
                () => {
                    this.startRecord = 0;
                    this.loadData();
                },
                searchQuery ? this.searchTimeoutTime : 0,
            );
        },

        currentPageLength () {
            this.startRecord = 0;
            this.loadData();
        },
    },

    methods: {
        toggleGroupExpanded (e, groupId) {
            if (['A', 'BUTTON', 'INPUT'].includes(e.target.nodeName)) {
                return;
            }

            const index = this.expandedGroups.indexOf(groupId);
            const isExpanded = index >= 0;
            if (isExpanded) {
                this.expandedGroups.splice(index, 1);
            } else {
                this.expandedGroups.push(groupId);
            }
        },
        groupIsExpanded (groupId) {
            if (! this.isGrouped) {
                return true;
            }

            return this.expandedGroups.includes(groupId);
            // || this.groupsIdsWithAtLeastOneRowSelected.includes(groupId);
        },

        selectElement (element, alertIfSelected = true) {
            if (! this.rowValueIsSelected(element) && this.selected) {
                this.selected.push(element);
            } else if (alertIfSelected) {
                this.$notify({
                    type: 'warning',
                    text: this.trans('app.datatable.already_selected'),
                });
            }
        },

        unselectElement (element) {
            const index = this.selected.findIndex(e => e === element);
            if (index >= 0) {
                this.selected.splice(index, 1);
            }
        },

        selectGroup (groupId) {
            const index = this.selectedGroups.findIndex(gId => gId === groupId);
            if (index < 0) {
                this.selectedGroups.push(groupId);
            }
        },

        selectGroupBy (groupBy) {
            this.groupBy = groupBy;

            pushUrlParam('group_by', groupBy);

            this.selectNone();
        },

        unselectGroup (groupId) {
            const index = this.selectedGroups.findIndex(gId => gId === groupId);
            if (index >= 0) {
                this.selectedGroups.splice(index, 1);
            }
        },

        getColumnContent (row, column) {
            if (this.columnRenderers[column.name]) {
                const fn = this.columnRenderers[column.name];
                return fn(row, column);
            }

            return row[column.name];
        },

        selectNone () {
            this.selected = [];
            this.selectedGroups = [];
        },

        /**
     * When an action button is clicked
     * @param  {String} action
     */
        doAction (action) {
            window.location.replace(this.actionLink(action));
        },

        /**
     * The action link
     * @param  {String} action
     */
        actionLink (action) {
            return `${this.ajaxQuery}&action=${action}`;
        },

        /**
     * If the column used as a param is visible
     * @param  {Object} column
     * @return {Boolean}
     */
        columnIsVisible (column) {
            return (
                _.findIndex(this.columnsToShow, columnName => column.name === columnName) >= 0
            );
        },

        /**
     * If the column used as a param should disable the search input
     * @param  {Object} column
     * @return {Boolean}
     */
        searchInputIsDisabled (column) {
            return column.searchable === false || column.filterable === false;
        },

        /**
     * Set the columns to show
     * @param {Object} columnsToShow
     */
        setColumnsToShow (columnsToShow) {
            this.columnsToShow = columnsToShow;
        },

        /**
     * Set the group by value
     * @param {Object} columnsToShow
     */
        setGroupBy (groupBy) {
            this.groupBy = groupBy;
        },

        /**
     * Set the table settings
     * @param {Object} settings
     */
        setSettings (settings) {
            this.settings = settings;
        },

        /**
     * The placeholder for the search input
     * @TODO Make the placeholders configurable?
     * @param  {Object} column
     * @return {String}
     */
        singleSearchPlaceholder (column) {
            if (this.searchInputIsDisabled(column)) {
                return null;
            }

            return 'Type to filter...';
        },

        hasAnySingleSearchOptionsColumn () {
            const searchOptionsColumns = _.filter(this.columns, column => _.get(column, 'searchable_options', false));

            return ! _.isEmpty(searchOptionsColumns);
        },

        async fetchSingleSearchAllColumnsOptions () {
            axios
                .get(`${this.ajaxQuery}&searchable_options=true`, {headers: { accept: 'application/json'}})
                .then(({ data }) => {
                    this.singleSearchOptions = data;
                })
                .catch(this.$handleException);
        },

        /**
     * Check if the searchable options column options values was async loaded.
     * @param  {Object} column
     * @return {Boolean}
     */
        hasSingleSearchOptionsLoaded (column) {
            return _.has(this.singleSearchOptions, column.name);
        },

        /**
     * The column options group by parameter from the Larael Datatable options.
     * @param  {Object} column
     * @return {String}
     */
        getColumnOptionsGroupByKey (column) {
            return _.get(column, 'searchable_options_group_by', null);
        },

        /**
     * Formmat the column options based on the datar type (Object or String) and fetch the key to
     * retrieve the right value.
     * @param  {Object} column
     * @return {String}
     */
        getFormattedColumnOptions (column) {
            let values = _.get(this.singleSearchOptions, column.name);
            const valueKey = _.get(column, 'searchable_options_value_key', 'name');

            if (_.isEmpty(values)) {
                return [];
            }

            if (_.isString(values[0])) {
                return _.map(values, item => ({
                    value: item,
                    data: item,
                }));
            }

            if (! _.isNull(this.getColumnOptionsGroupByKey(column))) {
                values = _.orderBy(this.singleSearchOptions[column.name], item => item[this.getColumnOptionsGroupByKey(column)], ['desc']);
            }

            return _.map(values, item => ({
                value: item[valueKey],
                data: item,
            }));
        },

        /**
     * Initializes the single search queries v-model
     *
     * @return {Object}
     */
        initSingleSearchQueries () {
            if (this.searchColumns) {
                const singleSearchQueries = {};
                this.searchColumns.forEach((value, index) => {
                    const column = this.columns[index];
                    singleSearchQueries[column.name] = value;
                });
                this.singleSearchQueries = singleSearchQueries;
            }
        },

        /**
     * The row value will always be the id of the object, but if there are no id will be the full
     * object
     *
     * @param  {Object} row
     * @return {String|Number}
     */
        rowValue (row) {
            if (row.id) {
                // Trick to remove HTML tags from the id (if exits)
                // The id should be a positive numeric value
                const tmp = document.createElement('DIV');
                tmp.innerHTML = row.id;
                const id = parseInt(tmp.textContent || tmp.innerText || row.id, 10);
                if (id) {
                    return id;
                }
            }

            return row;
        },

        /**
     * When a row is clicked
     *
     * @param  {Object} row
     */
        rowClicked (e, row) {
            if (! this.selectable || ['A', 'BUTTON', 'INPUT'].includes(e.target.nodeName)) {
                return;
            }

            const el = this.$refs[`checkbox-row-${row.id}`][0];
            const event = new Event('change');
            el.checked = ! el.checked;
            el.dispatchEvent(event);
        },

        /**
     * Handle the select list action link
     *
     * @param  {Object} action
     */
        handleAction (action) {
            // If the action has an event I will send the event to the event bus
            if (action.event) {
                OSPEvent.$emit(action.event, this.selectedRows);
            }

            // The action can also have callback methods (js functions that are defined as strings)
            // NOTE: The callback actions are a *temporaly* solution to add legacy compatibility with
            // old components, it should become deprecated once we update all the old components that
            // still needs javascript calls like jQuery modals, etc. for a better alternatives like Vue
            // events
            if (action.callback) {
                let fn;
                eval(`fn = ${action.callback}`);
                fn(this.selectedRows);
            }

            this.selected = [];
        },

        /**
     * Group is selected
     * @param  {String} groupId
     * @return {Boolean}
     */
        groupIsSelected (groupId) {
            return this.selectedGroups.indexOf(groupId) >= 0;
        },

        /**
     * If the row uses as a parameter is selected
     * @param  {Object} row
     * @return {Boolean}
     */
        rowIsSelected (row) {
            const rowValue = this.rowValue(row);
            return this.rowValueIsSelected(rowValue);
        },

        /**
     * If the row uses as a parameter is selected
     * @param  {Object} row
     * @return {Boolean}
     */
        rowValueIsSelected (rowValue) {
            return !! this.selected.find(item => {
                // Use the id when possible (exact)
                const itemValue = this.rowValue(item);

                // If are number are valid ids
                if (typeof itemValue === 'number' && typeof rowValue === 'number') {
                    return itemValue === rowValue;
                }

                // Fallback to compare the full object (sometimes is un-exact)
                return JSON.stringify(itemValue) === JSON.stringify(rowValue);
            });
        },

        /**
     * When a sort columns is clicked the column should replace the current active order unless
     * the user use shift, in that case it push the order to the columns
     * @param  {Event} e
     * @param  {String} name
     */
        sortBy (e, name) {
            const column = this.columns.find(c => c.name === name);
            if (column.orderable === false) {
                return;
            }

            const currentSorted = this.sortedColumns.find(cs => cs.sortBy === name);

            const sortBy = {
                sortBy: name,
                dir: ! currentSorted || currentSorted.dir === 'desc' ? 'asc' : 'desc',
            };

            if (e.shiftKey) {
                if (currentSorted) {
                    const index = _.findIndex(this.sortedColumns, cs => cs.sortBy === name);
                    Vue.set(this.sortedColumns, index, sortBy);
                } else {
                    this.sortedColumns.push(sortBy);
                }
            } else {
                this.sortedColumns = [sortBy];
            }
        },

        /**
     * Load the data trough ajax
     */
        async loadData () {
            // The timeout is used to avoid multiple ajax when various items in the ajax config
            // are updated at the same time (for example when components is created and it loads the
            // cached user settings)
            this.busy = true;
            clearTimeout(this.loadDataTimeout);
            this.loadDataTimeout = setTimeout(
                () => axios
                    .get(this.ajaxQuery, {headers: { accept: 'application/json'}})
                    .then(({ data }) => {
                        if (data.error) {
                            console.error(data.error);
                            this.$notify({
                                type: 'error',
                                text: this.trans('errors.occurred'),
                            });
                            return;
                        }

                        this.pagination = data;

                        // When we load the results for grouped items, every group only contains one item
                        // this second request should load the rest of every single loaded group.
                        // Notice that this is neccesary so the datatable pagination works with the groups.
                        if (this.isGrouped) {
                            this.groupedResultsIds = data.data.map(i => i[this.groupBy]);
                            this.loadingGroupItems = true;
                            axios.get(this.groupItemsAjaxQuery, {headers: { accept: 'application/json'}})
                                .then(({ data: itemsPagination }) => {
                                    this.pagination.data = _.unionBy(this.pagination.data, itemsPagination.data, item => `${item.id}-${item[this.groupBy]}`);
                                })
                                .catch(this.$handleExceptionAndAlert)
                                .then(() => {
                                    this.loadingGroupItems = false;
                                });
                        }
                    })
                    .catch(this.$handleExceptionAndAlert)
                    .then(() => {
                        this.busy = false;
                    }),
                500,
            );
        },

        /**
     * The class of the header columns according to the current options
     * @param  {Number} index
     * @return {Object}
     */
        thClass (index) {
            const column = this.columns[index];
            const columnName = column.name;
            const sortedColumn = this.sortedColumns.find(
                sc => sc.sortBy === columnName,
            );
            const orderable = ! (this.columns[index].orderable === false);
            const classes = {
                'Datatable--header': true,
                sorting: orderable,
                sorting_disabled: ! orderable,
                sorting_desc: sortedColumn && sortedColumn.dir === 'desc',
                sorting_asc: sortedColumn && sortedColumn.dir === 'asc',
            };
            if (column.class) {
                classes[column.class] = true;
            }
            return classes;
        },
    },

    created () {
        if (this.echoChannel) {
            Echo.private(this.echoChannel)
            // When a kit inventory is updated it emits the following event, that event contains
            // the related kits created. So I loop through the loop of kits and emits the event that
            // update with the current total
                .listen('KitsInventoryUpdated', ({ kits }) => {
                    kits.forEach(({ id: rowId, total_items: totalItems }) => {
                        const columnName = 'item';
                        OSPEvent.$emit('datatable-refresh-column', rowId, columnName, totalItems);
                    });
                });
        }

        OSPEvent.$on('datatable-refresh-column', (rowId, columnName, newValue) => {
            // Find an element in the results data with an object with the same id
            const rowKey = _.findKey(this.results, row => row.id && String(row.id) === String(rowId));

            if (typeof rowKey !== 'undefined') {
                // Find the attribute in the object that I will update
                const columnKey = _.findKey(
                    this.results[rowKey],
                    (value, attribute) => columnName === attribute,
                );

                if (typeof columnKey !== 'undefined') {
                    // Update the value in the array of results that should update the value in the table
                    this.results[rowKey][columnKey] = newValue;
                }
            }
        });

        // Adding a column renderer allow u to override the method that read the column data
        // it expect a clousure that receive the row and column
        // example:
        // ```
        // bus.$emit('datatable-add-column-renderer', (row, column) => {
        //    return row[column.name] * 2
        // }
        // ```
        OSPEvent.$on('datatable-add-column-renderer', (columnName, clousure) => {
            this.columnRenderers[columnName] = clousure;
        });

        OSPEvent.$on('datatable-select-element', itemToSelect => {
            this.selectElement(itemToSelect);
        });

        OSPEvent.$on('datatable-filter-column', (column, query) => {
            this.singleSearchQueries[column] = query;
        });

        if (this.orderColumn && this.orderDirection) {
            this.sortedColumns = [
                {
                    dir: this.orderDirection,
                    sortBy: this.columns[this.orderColumn].name,
                },
            ];
        }

        this.initSingleSearchQueries();

        const userConfig = JSON.parse(localStorage.getItem(this.localStorageKey));
        if (userConfig) {
            if (! userConfig.settings || ! userConfig.settings.saveState) {
                delete userConfig.searchQuery;
                delete userConfig.singleSearchQueries;
            }

            Object.assign(this.$data, userConfig);
        }

        this.loadData();

        if (this.hasAnySingleSearchOptionsColumn()) {
            this.fetchSingleSearchAllColumnsOptions();
        }
    },

    mounted () {
        _.each(this.$refs, (ref, key) => {
            if (key.startsWith('date-picker')) {
                const panelComponent = ref[0].$children[1];

                if (panelComponent.calendarMonth === 11) {
                    panelComponent.changeCalendarMonth(0);
                    panelComponent.changeCalendarYear(panelComponent.calendarYear + 1);
                } else {
                    panelComponent.changeCalendarMonth(panelComponent.calendarMonth + 1);
                }
            }
        });
    },
};
</script>
